import React, { useEffect, useState } from "react"
import { Card, CardHeader, CardBody, Col, Row, Nav, NavItem, NavLink } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import classnames from "classnames"
import JournalEntryFilter from "./filter"
import UpdateTable from "../../../components/Common/UpdatedTable"
import NumberFormat from "../../../utils/numberFormat"
import moment from "moment"
import { useLocation, useNavigate } from "react-router-dom"
import { fetchFinanceLedgerAccBook } from "../../../services/finance/finance"

const tabCardData = [
     {
          quickLinks: [
               { id: "1", label: "Bank Book" },
               { id: "2", label: "BRS" },
          ],
     },
     {
          quickLinks: [
               { id: "3", label: "Cash Book" },
               { id: "4", label: "Ledger Book" },
               { id: "5", label: "Sales Register" },
               { id: "6", label: "Purchase Register" },
               { id: "7", label: "Recipt Book" },
               { id: "8", label: "Payment Book" },
               { id: "9", label: "Journal Book" },
          ],
     },
     {
          quickLinks: [
               { id: "10", label: "Stock Summary" },
               { id: "11", label: "Stock Journal" },
               { id: "12", label: "GRN" },
               { id: "13", label: "Delivery Note" },
               { id: "14", label: "Manufacturing Journal" },
          ],
     },
     {
          quickLinks: [
               { id: "15", label: "Cash Flow" },
               { id: "16", label: "Fund Flow" },
          ],
     },
     {
          quickLinks: [
               { id: "17", label: "Working Capital" },
               { id: "18", label: "Current Ratio" },
               { id: "19", label: "Debt Equity Ratio" },
          ],
     },
]

const NewLedgerAccounts = ({ fromDashboard }) => {
     const location = useLocation()
     const navigate = useNavigate()
     const [acc, setAcc] = useState(
          location?.state?.item?.ledger_id ||
          location?.state?.ledger_id ||
          location?.state?.id ||
          null
     )
     const [filterKey, setFilterKey] = useState(0);
     const [fetchedData, setFetchedData] = useState()
     const [page, setPage] = useState(1)
     const [desimalrange] = useState(localStorage.getItem("desimalrange") || 2)
     const [search, setSearch] = useState("")
     const [dateFrom, setDatefrom] = useState("")
     const [dateTo, setDateto] = useState("")
     const [refresh, setRefresh] = useState(0)
     const [activeTab, setActiveTab] = useState("1")
     const [cardOpen, setCardOpen] = useState(true)
     const [activeQuickLinkId, setActiveQuickLinkId] = useState(tabCardData[0].quickLinks[0].id)
     useEffect(() => {
          const fetchData = async () => {
               try {
                    setFetchedData(null)
                    const ledgerId =
                         acc
                              ? acc
                              : location?.state?.item?.ledger_id ||
                              location?.state?.ledger_id ||
                              location?.state?.id ||
                              location?.state?.item?.id ||
                              "";
                    const response = await fetchFinanceLedgerAccBook({
                         params: `${search ? `&searchText=${search}` : "&searchText"}${page ? `&page=${page}` : ""
                              }${dateFrom ? `&start_date=${moment(dateFrom).format("YYYY-MM-DD")}` : ""
                              }${dateTo ? `&end_date=${moment(dateTo).format("YYYY-MM-DD")}` : ""
                              }${`&sizePerPage=16`}${ledgerId ? `&ledger_id=${ledgerId}` : ""
                              }`,
                    })
                    setFetchedData(response)
               } catch (error) {
                    console.error("Error fetching data:", error)
               }
          }

          if (
               acc !== undefined ||
               location?.state?.item?.ledger_id ||
               location?.state?.ledger_id ||
               location?.state?.id ||
               location?.state?.item?.id
          ) {
               fetchData()
          }
     }, [page, refresh, location, acc, dateFrom, dateTo])
     const columns = [
          // ...(shouldShowLedgerColumn ? [
          // {
          //   label: "Ledger",
          //   renderCell: item => (
          //     <div className="text-capitalize">
          //       {item?.ledger?.name ? item?.ledger?.name : "-"}
          //     </div>
          //   ),
          // },
          // ]: []),
          {
               label: "Date",
               renderCell: item => (
                    <span>{moment(item?.transaction_date).format("DD-MMM-YYYY")}</span>
               ),
          },
          {
               label: "Particulars",
               renderCell: item => (
                    <div className="text-capitalize">{item?.entries[0]?.ledger_name}</div>
               ),
          },
          {
               label: "Voucher Type",
               renderCell: item => (
                    <div className="text-capitalize">{item?.voucher_type}</div>
               ),
          },
          {
               label: "Voucher No",
               renderCell: item => (
                    <div
                         className="text-capitalize pointer fw-bold"
                         onClick={() => navigate(`/finance-voucher/view/${item?.id}`)}
                    >
                         {item?.reference_number}
                    </div>
               ),
          },
          // {
          //   label: "Date",
          //   renderCell: item => moment(item?.created_at).format("DD-MMM-YYYY"),
          // },
          {
               label: <div className="text-end pe-5">Debit (AED)</div>,
               renderCell: item => (
                    <div className="text-end pe-5">
                         {item?.side == "debit"
                              ? NumberFormat(Math.abs(Number(item?.amount)), desimalrange, desimalrange)
                              : NumberFormat(0, desimalrange, desimalrange)}{" "}
                         {/* {Number(item?.amount) > 0 ? "Cr" : "Dr"} */}
                    </div>
               ),
          },
          {
               label: <div className="text-end pe-5">Credit (AED)</div>,
               renderCell: item => (
                    <div className="text-end pe-5">
                         {item?.side == "credit"
                              ? NumberFormat(Math.abs(Number(item?.amount)), desimalrange, desimalrange)
                              : NumberFormat(0, desimalrange, desimalrange)}{" "}
                         {/* {Number(item?.amount) > 0 ? "Cr" : "Dr"} */}
                    </div>
               ),
          },
     ]

     const handlePaginate = page => {
          setPage(page)
     }
     const toggle = tab => {
          if (activeTab !== tab) {
               setActiveTab(tab)
               const tabIdx = Number(tab) - 1
               setActiveQuickLinkId(tabCardData[tabIdx]?.quickLinks[0]?.id)
          }
     }

     const getCardData = () => {
          switch (activeTab) {
               case "1":
                    return tabCardData[0]
               case "2":
                    return tabCardData[1]
               case "3":
                    return tabCardData[2]
               case "4":
                    return tabCardData[3]
               case "5":
                    return tabCardData[4]
               default:
                    return { quickLinks: [] }
          }
     }

     const cardData = getCardData()

     return (
          <React.Fragment>
               <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
                    <div className="container-fluid">
                         <div>
                              <Breadcrumbs
                                   title="Finance"
                                   breadcrumbObject={[
                                        { title: "Finance", link: "/finance" },
                                        { title: "Ledgers", link: "/finance-ledger" },
                                        { title: "Ledger Account", link: "/finance-ledger-acc" },
                                   ]}
                              />
                         </div>
                         <JournalEntryFilter
                          key={filterKey}
                              handleSearchChange={() => { }}
                              handleDateChange={() => { }}
                              handleAccChange={data => {
                                   setAcc(data)
                                   setPage(1)
                                   setRefresh(refresh + 1) // This will trigger useEffect and fetch new data
                              }}
                              handleVoucherTypeChange={() => { }}
                         />
                         <Row className="mt-3">
                              <Col lg={9}>
                                   <Card className="mb-3">
                                        <CardBody>
                                             {/* Tabs */}
                                             <Nav tabs>
                                                  <NavItem>
                                                       <NavLink
                                                            className={classnames("cursor-pointer", { active: activeTab === "1" })}
                                                            onClick={() => { toggle("1"); setCardOpen(true) }}
                                                       >
                                                            Banking
                                                       </NavLink>
                                                  </NavItem>
                                                  <NavItem>
                                                       <NavLink
                                                            className={classnames("cursor-pointer", { active: activeTab === "2" })}
                                                            onClick={() => { toggle("2"); setCardOpen(true) }}
                                                       >
                                                            Account Book
                                                       </NavLink>
                                                  </NavItem>
                                                  <NavItem>
                                                       <NavLink
                                                            className={classnames("cursor-pointer", { active: activeTab === "3" })}
                                                            onClick={() => { toggle("3"); setCardOpen(true) }}
                                                       >
                                                            Inventory Book
                                                       </NavLink>
                                                  </NavItem>
                                                  <NavItem>
                                                       <NavLink
                                                            className={classnames("cursor-pointer", { active: activeTab === "4" })}
                                                            onClick={() => { toggle("4"); setCardOpen(true) }}
                                                       >
                                                            Advance Report
                                                       </NavLink>
                                                  </NavItem>
                                                  <NavItem>
                                                       <NavLink
                                                            className={classnames("cursor-pointer", { active: activeTab === "5" })}
                                                            onClick={() => { toggle("5"); setCardOpen(true) }}
                                                       >
                                                            Ratio Analysis
                                                       </NavLink>
                                                  </NavItem>
                                             </Nav>
                                             {(
                                                  (acc !== null && acc !== undefined) ||
                                                  location?.state?.item?.ledger_id ||
                                                  location?.state?.ledger_id ||
                                                  location?.state?.id ||
                                                  location?.state?.item?.id
                                             ) ? (
                                                  <>
                                                       <div className="d-flex justify-content-between px-2 py-3 fw-600">
                                                            {location?.state?.item?.ledger_name ||
                                                                 location?.state?.name ||
                                                                 location?.state?.ledger_name ? (
                                                                 <div>
                                                                      Ledger:{" "}
                                                                      {location?.state?.item?.ledger_name
                                                                           ? location?.state?.item?.ledger_name
                                                                           : location?.state?.name
                                                                                ? location?.state?.name
                                                                                : location?.state?.ledger_name}
                                                                 </div>
                                                            ) : null}
                                                            <div>
                                                                 Opening Balance:{" "}
                                                                 {fetchedData?.closingBalance
                                                                      ? `${NumberFormat(
                                                                           Math.abs(Number(fetchedData?.openingBalance)),
                                                                           desimalrange,
                                                                           desimalrange
                                                                      )} AED`
                                                                      : "-"}
                                                            </div>
                                                            <div>
                                                                 Current Balance:{" "}
                                                                 {fetchedData
                                                                      ? `${NumberFormat(
                                                                           Math.abs(
                                                                                Number(fetchedData?.closingBalance || 0) -
                                                                                Number(fetchedData?.openingBalance || 0)
                                                                           ),
                                                                           desimalrange,
                                                                           desimalrange
                                                                      )} AED`
                                                                      : "-"}
                                                            </div>
                                                            <div>
                                                                 Closing Balance:{" "}
                                                                 {fetchedData?.closingBalance
                                                                      ? `${NumberFormat(
                                                                           Math.abs(Number(fetchedData?.closingBalance)),
                                                                           desimalrange,
                                                                           desimalrange
                                                                      )} AED`
                                                                      : "-"}
                                                            </div>
                                                       </div>
                                                       <Row className="mt-2 ever-rise-table accTable">
                                                            <Col xs={12}>
                                                                 {fetchedData?.data?.data && (
                                                                      <UpdateTable
                                                                           className="mt-5"
                                                                           nodes={fetchedData?.data?.data}
                                                                           paginate={fetchedData?.data}
                                                                           CurrentPage={page}
                                                                           columns={columns}
                                                                           handlePagination={handlePaginate}
                                                                           tableWidth="12% 20% 20% 10% 20% 17%"
                                                                           mobileWidth="40% 40% 30% 30% 30% 30%"
                                                                      />
                                                                 )}
                                                            </Col>
                                                       </Row>
                                                  </>
                                             ) : (
                                                  <div className="d-flex justify-content-center pt-5">
                                                       Please Select Ledger
                                                  </div>
                                             )}
                                        </CardBody>
                                   </Card>
                              </Col>
                              <Col lg={3}>
                                   {cardOpen && (
                                        <Card className="financeVoucher-card">
                                             <CardHeader className="header-menu-avtive py-1 px-1">
                                                  <div className="d-flex justify-content-between">
                                                       <div className="quicklinks ps-2">Quick Links</div>
                                                       <div className="pe-2">
                                                            <span
                                                                 style={{ cursor: "pointer", fontWeight: "bold" }}
                                                                 className="cancel-of-financeV"
                                                                 onClick={() => setCardOpen(false)}
                                                            >
                                                                 ×
                                                            </span>
                                                       </div>
                                                  </div>
                                             </CardHeader>
                                             <CardBody className="py-0 pe-0 scroll-of-finance">
                                                  <div className="mt-2">
                                                       {cardData.quickLinks.map((item) => (
                                                            <div
                                                                 className={`pb-2 list-of-finace${activeQuickLinkId === item.id ? " active" : ""}`}
                                                                 key={item.id}
                                                                 id={item.id}
                                                                 style={{ cursor: "pointer" }}
                                                                 onClick={() => {
                                                                      setActiveQuickLinkId(item.id)
                                                                      setAcc(null)
                                                                      setDatefrom("")
                                                                      setDateto("")
                                                                      setSearch("")
                                                                      setPage(1)
                                                                      setRefresh(refresh + 1)
                                                                      setFilterKey(prev => prev + 1)
                                                                 }}
                                                            >
                                                                 {item.label}
                                                            </div>
                                                       ))}
                                                  </div>
                                             </CardBody>
                                        </Card>
                                   )}
                              </Col>
                         </Row>
                    </div>
               </div>
          </React.Fragment>
     )
}

export default NewLedgerAccounts